export class TransactionMethodEvaluationResponse {
  transactionId: number;
  identifier: string;
  propertyTransferred: string;
  transferDateDay: number;
  transferDateMonth: number;
  transferDateYear: number;
  units: number;
  value: number;
  description: string;
}
